import { flip, prop } from 'ramda';
import { useContext } from 'react';

import { enableExperimentFeatures } from '@/config/experiment-feature-toggles';
import { FeatureToggleContext } from '@/contexts/feature-toggle';
import { useAbTastyTests } from '@/hooks/use-ab-tasty-tests';

const propForObject = flip(prop);

export const useFeatureToggle = () => {
  const { enabledFeatures } = useContext(FeatureToggleContext);
  if (!enabledFeatures['ab-tasty']) {
    return { isEnabled: propForObject(enabledFeatures) };
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks -- Condition is project-wide
  const abTastyTests = useAbTastyTests();

  const experimentFeatures = enableExperimentFeatures(
    enabledFeatures,
    abTastyTests
  );

  return { isEnabled: propForObject(experimentFeatures) };
};
